import { render } from "./SurveyPopup.vue?vue&type=template&id=4ca7c892&scoped=true"
import script from "./SurveyPopup.vue?vue&type=script&lang=js"
export * from "./SurveyPopup.vue?vue&type=script&lang=js"

import "./SurveyPopup.vue?vue&type=style&index=0&id=4ca7c892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca7c892"]])

export default __exports__